// Get all social sharing links
document.querySelectorAll( '.biro-component-social-share .link' )

  // For each sharing link
  .forEach( function ( socialSharingLink ) {

    // Add an event listener for a click
    socialSharingLink.addEventListener( 'click', function( e ) {

      // Stop the link being followed
      e.preventDefault();

      // Open the popup
      // We use a unique id for each one in case the visitor
      // clicks two links, otherwise the URL will be loaded
      // in the old window, which may be behind the main window
      // at that point
      window.open( e.target.href, 'sharer-' + Date.now(), 'popup=true,width=600,height=600,noopener,noreferrer' );

    } );

  } );
